export default {
  GET_VIDEO_LIST: '/manage/introductionVideo/findList',
  GET_SEGMENT_LIST: '/auth/trendCategory/findFilterByPid',
  SAVE_VIDEO: '/manage/introductionVideo/save',
  GET_VIDEO_DETAIL: '/manage/introductionVideo/find',
  UPDATE_DETAIL: '/manage/introductionVideo/update',
  UPDATE_STATUS: '/manage/introductionVideo/updateStatus'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/videoManagement.js